import { formatCurrency } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ClashDto } from '@models/embate/clash-dto';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { IPutForm } from '@models/form/put/put-form';
import { FormBase } from '@models/portal/users/form-base';
export class ChaveEmbateForm extends FormBase implements IPutForm {
  cheTxNome?: string;
  cheNrEtapa?: number;
  cheBlEmbGerados?: boolean;
  cheNrQtdInc?: number;
  cheNrQtdVencedor?: number;


  verifyChanges(currentState?: ClashDto): void {

    console.log(currentState);
    console.log('currentState');

    if (!currentState) return


    const hasChanges =
    this.cheTxNome !== currentState.cheTxNome ||
    this.cheNrEtapa !== currentState.cheNrEtapa ||
    this.cheBlEmbGerados !== currentState.cheBlEmbGerados ||
    this.cheNrQtdInc !== currentState.cheNrQtdInc ||
    this.cheNrQtdVencedor !== currentState.cheNrQtdVencedor;

    this.entTxMetadado = hasChanges
    ? MetadataPutEnum.ALTERADO
    : MetadataPutEnum.INALTERADO;
  }
}

export function buildChaveEmbateForm(dto?: Partial<ClashDto>): ChaveEmbateForm {

  const form = new ChaveEmbateForm();

  if (!dto) {
    // Novo registro
    form.entTxMetadado = MetadataPutEnum.CRIADO;
  }else {
    form.entTxMetadado = MetadataPutEnum.INALTERADO;
  }

  form.entNrId = dto?.cheNrId
  form.cheTxNome = dto?.cheTxNome;
  form.cheNrEtapa = dto?.cheNrEtapa;
  form.cheBlEmbGerados = dto?.cheBlEmbGerados;
  form.cheNrQtdInc = dto?.cheNrQtdInc;
  form.cheNrQtdVencedor = dto?.cheNrQtdVencedor;

  return form
}

export interface ChaveEmbateFg {
  cheNrId: FormControl<number | null>;
  cheTxNome: FormControl<string | null>;
  cheNrEtapa: FormControl<number | null>;
  cheBlEmbGerados: FormControl<boolean | null>;
  cheNrQtdInc: FormControl<number | null>;
  cheNrQtdVencedor: FormControl<number | null>;
}

export function createChaveEmbateFgFromDto(
  dto: ClashDto,
  fb: FormBuilder,
): FormGroup<ChaveEmbateFg> {

  return fb.group<ChaveEmbateFg>({
    cheNrId: fb.control(dto.cheNrId || null),
    cheTxNome: fb.control(dto.cheTxNome || null),
    cheNrEtapa: fb.control(dto.cheNrEtapa || null),
    cheBlEmbGerados: fb.control(dto.cheBlEmbGerados || null),
    cheNrQtdInc: fb.control(dto.cheNrQtdInc || null),
    cheNrQtdVencedor: fb.control(dto.cheNrQtdVencedor || null),
  });
}
